import React from 'react';
import styled from 'styled-components';

const FooterContainer = styled.footer`
  background-color: #121E42;
  color: white;
  padding: 40px 0 20px;
  border-top: 1px solid rgba(0, 229, 255, 0.2);
`;

const FooterContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const FooterLogo = styled.img`
  max-width: 150px;
  margin-bottom: 20px;
`;

const FooterText = styled.p`
  text-align: center;
  margin-bottom: 10px;
  font-size: 0.9rem;
`;

const FooterLinks = styled.div`
  margin: 15px 0;
`;

const FooterLink = styled.a`
  color: #00E5FF;
  margin: 0 10px;
  text-decoration: none;
  transition: all 0.3s ease;
  
  &:hover {
    color: white;
    text-decoration: underline;
  }
`;

const Copyright = styled.p`
  font-size: 0.8rem;
  margin-top: 20px;
  text-align: center;
  color: rgba(255, 255, 255, 0.7);
`;

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <FooterContainer>
      <div className="container">
        <FooterContent>
          <FooterLogo src="/images/logo-grupo-nobre-footer.png" alt="Logo Grupo Nobre" />
          <FooterText>Grupo Nobre Educação</FooterText>
          <FooterText>Referência nacional em formação de especialistas na saúde</FooterText>
          
          <FooterLinks>
            <FooterLink href="https://www.nobreeducacao.com.br/politica-de-privacidade" target="_blank" rel="noopener noreferrer">
              Política de Privacidade
            </FooterLink>
            <FooterLink href="https://www.nobreeducacao.com.br" target="_blank" rel="noopener noreferrer">
              Site Oficial
            </FooterLink>
          </FooterLinks>
          
          <Copyright>
            &copy; {currentYear} Grupo Nobre. Todos os direitos reservados.
          </Copyright>
        </FooterContent>
      </div>
    </FooterContainer>
  );
};

export default Footer;
